import osType from './osType';

export default function (info) {
  return info.muted || info.audio === -1 || (info.autoplay && !osType.isPC());
}



// WEBPACK FOOTER //
// ./src/common/isUsingAudioMock.js